<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/tag/add')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <!-- <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      @change="parkChange"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.status"
      placeholder="请选择使用状态"
    >
      <el-option label="全部状态" value=""></el-option>
      <el-option label="启用" value="1"></el-option>
      <el-option label="停用" value="2"></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.module"
      placeholder="请选择功能模块"
    >
      <el-option label="全部模块" value=""></el-option>
      <el-option label="报事报修" value="1"></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.type"
      placeholder="请选择业主类型"
    >
      <el-option label="全部类型" value=""></el-option>
      <el-option label="物业" value="1"></el-option>
      <el-option label="业主" value="2"></el-option>
    </el-select>
    <el-input
      style="float: right; margin-right: 10px; width: 200px"
      v-model="screen.title"
      placeholder="请输入标签名称"
    ></el-input>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="标签名称" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序">
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <el-table-column label="业主类型" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "物业" : "业主" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="功能模块" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.module == 1 ? "报事报修" : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "停用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row, 'see')"
            v-if="roles.includes('/tag/info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row, 'edit')"
            v-if="roles.includes('/tag/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/tag/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="标签名称"
          prop="name"
          :rules="{
            required: true,
            message: '请输入标签名称',
            trigger: 'blur',
          }"
        >
          <el-input
            class="w4"
            :disabled="cztype == 'see'"
            v-model="ruleForm.name"
            placeholder="请输入标签名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="type"
          label="业主类型"
          :rules="{
            required: true,
            message: '请选择业主类型',
            trigger: 'change',
          }"
        >
          <el-radio-group :disabled="cztype == 'see'" v-model="ruleForm.type">
            <el-radio :label="1">物业</el-radio>
            <el-radio :label="2">业主</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          prop="module"
          label="功能模块"
          :rules="{
            required: true,
            message: '请选择功能模块',
            trigger: 'change',
          }"
        >
          <el-radio-group :disabled="cztype == 'see'" v-model="ruleForm.module">
            <el-radio :label="1">报事报修</el-radio>
            <!-- <el-radio :label="2">业主</el-radio> -->
          </el-radio-group>
        </el-form-item>

        <el-form-item
          prop="status"
          label="使用状态"
          :rules="{
            required: true,
            message: '请选择使用状态',
            trigger: 'change',
          }"
        >
          <el-radio-group :disabled="cztype == 'see'" v-model="ruleForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sort"
          :rules="{
            required: true,
            message: '请输入排序',
            trigger: 'blur',
          }"
        >
          <el-input
            class="w4 numInput"
            type="number"
            min="0"
            placeholder="请输入排序"
            v-model="ruleForm.sort"
            :disabled="cztype == 'see'"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <!-- <el-button
            type="primary"
            @click="(cztype = 'edit'), (drawerTitle = '编辑')"
            v-if="cztype == 'see' && roles.includes('/enterprise/edit_type')"
          >
            编辑
          </el-button> -->
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit' || cztype == 'see'"
            type="info"
            @click="drawer = false"
          >
            关闭
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage } from "@/api/index";
import {
  tagLists,
  tagAdd,
  tagEdit,
  tagDel,
  tagInfo,
  // intention_user,
} from "@/api/tag";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        name: "",
        type: "",
        module: "",
        status: "",
      },
      total: 0,
      ruleForm: {},

      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    this.fetchData();
    this.getPark();
  },
  methods: {
    parkChange(e) {},
    formParkChange() {},
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        is_page: 1,
        name: "",
        type: "",
        module: "",
        status: "",
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.screen.park_id = this.userInfo.park_id;
      // } else {
      //   this.screen.park_id = "";
      // }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              tagEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      tagInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          sort: res.data.info.sort,
          name: res.data.info.name,
          type: res.data.info.type,
          module: res.data.info.module,
          status: res.data.info.status,
        };
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          tagDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              tagAdd(this.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        name: "",
        sort: "",
        type: "",
        module: "",
        status: "",
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.ruleForm.park_id = this.userInfo.park_id;
      // }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      tagLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
